import TrustScoreFormSession from 'syf-trustscore-bank/dist/transmit/websdk/js/trustscore/TrustScoreFormSession';
import OtpFormSession from 'syf-otp-bank/dist/transmit/websdk/js/otp/OtpFormSession';
export default function BaseUIHandler(path) {
    var handlePolicyRejection = function () {
        return Promise.resolve(window.com.ts.mobile.sdk.ConfirmationInput.create(-1));
    };
    var processJsonData = function () {
        return Promise.resolve(window.com.ts.mobile.sdk.JsonDataProcessingResult.create(true));
    };
    var startActivityIndicator = function () {
    };
    var endActivityIndicator = function () {
    };
    var controlFlowStarting = function () {
    };
    var controlFlowEnded = function () {
    };
    var controlFlowActionStarting = function () {
    };
    var controlFlowActionEnded = function () {
    };
    function createFormSession(formId, payload) {
        switch (path) {
            case 'TrustScoreSdkComponent':
                return TrustScoreFormSession(formId, payload);
            case 'OtpSdkComponent':
                return OtpFormSession(formId, payload);
            default:
                return null;
        }
    }
    function controlOptionForCancellationRequestInSession() {
        return Promise.resolve(window.com.ts.mobile.sdk.ControlRequest.create(window.com.ts.mobile.sdk.ControlRequestType.AbortAuthentication));
    }
    var handlePolicyRedirect = function () {
        return Promise.resolve(window.com.ts.mobile.sdk.RedirectInput.create(window.com.ts.mobile.sdk.RedirectResponseType.RedirectToPolicy));
    };
    return {
        handlePolicyRejection: handlePolicyRejection,
        processJsonData: processJsonData,
        createFormSession: createFormSession,
        startActivityIndicator: startActivityIndicator,
        endActivityIndicator: endActivityIndicator,
        controlFlowStarting: controlFlowStarting,
        controlFlowEnded: controlFlowEnded,
        controlFlowActionStarting: controlFlowActionStarting,
        controlFlowActionEnded: controlFlowActionEnded,
        handlePolicyRedirect: handlePolicyRedirect,
        controlOptionForCancellationRequestInSession: controlOptionForCancellationRequestInSession
    };
}
